export default {
  'admin.employee.create.success': 'Successfully added new user',
  'admin.employee.update.success': 'Successfully updated user',
  'admin.employee.disable.success': 'Successfully disabled user',
  'admin.employee.enable.success': 'Successfully enabled user',
  'admin.color.update.success': 'Successfully updated colors',
  'admin.employee.disable.confirm': 'Are you sure you want to disable this user?',
  'admin.employee.enable.confirm': 'Are you sure you want to enable this user?',
  'admin.employee.filed.name': 'Name',
  'admin.employee.filed.type': 'Type',
  'admin.employee.filed.permissions': 'Permissions',
  'admin.employee.filed.type.placeholder': 'Please Select type',
  'admin.employee.title': 'Employee',
  'admin.employee.add.disabled': 'Please contact SmartForwarder to add new user',
  'admin.employee.add.blocked_login_only':
    'User limit reached, new users can only be added with login blocked',
  'admin.tracking_users.create.success': 'Successfully added new tracking user',
  'admin.tracking_users.update.success': 'Successfully updated tracking user',
  'admin.tracking_users.disable.confirm': 'Are you sure you want to disable this tracking user?',
  'admin.tracking_users.disable.success': 'Successfully disabled tracking user',
  'admin.tracking_users.enable.confirm': 'Are you sure you want to enable this tracking user?',
  'admin.tracking_users.enable.success': 'Successfully enabled tracking user',
  'admin.tracking_users.add.title': 'Add Tracking User',
  'admin.tracking_users.edit.title': 'Edit Tracking User',
  'admin.tracking_users.details.title': 'Tracking User Details',
  'admin.tracking_users.title': 'Tracking Users',
  'admin.tracking_users.part_of': 'Part of',
  'admin.portal_profiles.title': 'Portal Profiles',
  'admin.portal_profiles.description':
    'A profile sets which shipment fields and document types a tracking user can see. Assign it on Tracking Users. Fields not in the profile are never sent to that user.',
  'admin.portal_profiles.add': 'Add Profile',
  'admin.portal_profiles.edit': 'Edit Profile',
  'admin.portal_profiles.name': 'Name',
  'admin.portal_profiles.description_field': 'Description',
  'admin.portal_profiles.fields': 'Visible Fields',
  'admin.portal_profiles.reset_default': 'Reset to Default',
  'admin.portal_profiles.document_types': 'Document Types',
  'admin.portal_profiles.document_types.all': 'All document types',
  'admin.portal_profiles.document_types.none': 'No documents',
  'admin.portal_profiles.users_count': 'Users',
  'admin.portal_profiles.in_use': 'Assigned to tracking users. Reassign them before deleting.',
  'admin.portal_profiles.delete.confirm': 'Delete the profile "{name}"?',
  'admin.portal_profiles.saved': 'Profile saved',
  'admin.portal_profiles.deleted': 'Profile deleted',
  'admin.portal_profiles.group.reference': 'References',
  'admin.portal_profiles.group.party': 'Parties',
  'admin.portal_profiles.group.routing': 'Routing',
  'admin.portal_profiles.group.date': 'Dates & Cut-offs',
  'admin.portal_profiles.group.cargo': 'Cargo',
  'admin.portal_profiles.group.container': 'Containers',
  'admin.portal_profiles.group.status': 'Status & Tracking',
  'admin.tracking_users.portal_contacts': 'Additional Contacts',
  'admin.tracking_users.portal_contacts.extra': 'This user also sees shipments of these companies.',
  'admin.tracking_users.portal_contacts.add': 'Add Contact',
  'admin.tracking_users.portal_party_fields': 'Sees shipments where the company is',
  'admin.tracking_users.portal_party_fields.extra': 'Leave empty to use the shop default.',
  'admin.tracking_users.portal_profile': 'Portal Profile',
  'admin.tracking_users.portal_profile.default': 'Default',
  'admin.ams_agent.create.success': 'Successfully added new AMS agent',
  'admin.ams_agent.update.success': 'Successfully updated AMS agent',
  'admin.ams_agent.disable.confirm': 'Are you sure you want to disable this AMS agent?',
  'admin.ams_agent.disable.success': 'Successfully disabled AMS agent',
  'admin.ams_agent.enable.confirm': 'Are you sure you want to enable this AMS agent?',
  'admin.ams_agent.enable.success': 'Successfully enabled AMS agent',
  'admin.ams_agent.add.title': 'Add AMS Agent',
  'admin.ams_agent.edit.title': 'Edit AMS Agent',
  'admin.ams_agent.details.title': 'AMS Agent Details',
  'admin.ams_agent.title': 'AMS Agents',
  'admin.ams_agent.part_of': 'Part of',
};
